export default "__VITE_ASSET__C1tU1$P6__"